/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const VietnamNLIHP = lazy(() => import('./pages/VietnamNLIHP'))

export default [<SiteRoute key="nlihp" exact path="/" component={VietnamNLIHP} />]
